import { getApi } from "@beeldit/core/helpers/api";

export default async function replicateDeliveryNote(id: number): Promise<number> {
  const response = await getApi().post(`/invoices/${id}/replicate`, {});
  // Se espera que el backend devuelva el nuevo ID en response.data.id
  return response.data?.id ?? response.data;
}
